<script setup>
/* eslint-disable vue/no-setup-props-destructure */
    import { onMounted, ref, defineProps } from 'vue';
    import { doc, onSnapshot } from 'firebase/firestore';
    import { db } from '@/firebase';

    import { utcToLocal } from '@/tools/TimeFunctions';


    const props = defineProps({
        dataID: String,
        timeFormat: {
            type: String,
            default: '24hour'
        }
    });

    /**
     * Initates the creation of the table
     */
    const tableData = ref(new Map([
        ['Time Stamp', []],
        ['Event', []]
    ]));

    onMounted(() => {
        grabData();
    });

    /**
     * Grab data from the data collection
     */
    const grabData = () => {
        onSnapshot(doc(db, "data", props.dataID), (document) => {
            const docData = document.data();
            let timestamps = tableData.value.get('Time Stamp');
            let events = tableData.value.get('Event')

            timestamps.unshift(utcToLocal(docData.lastActivityUTC, props.timeFormat));
            events.unshift(docData.lastMessage);

            if (timestamps.length > 5) {
                timestamps.pop();
                events.pop();
            }

            tableData.value.set('Time Stamp', timestamps);
            tableData.value.set('Event', events);
        });
    };

</script>

<template>
    <div class="bg-white rounded-md p-2 sm:p-3">
        <h1 class="text-lg sm:text-xl font-semibold mb-2" style="margin-top: 0;">Event Log</h1>
        <div class="overflow-x-auto">
            <table class="w-full bg-white border-collapse min-w-[300px]">
                <colgroup>
                    <col class="w-[40%] sm:w-[30%]">
                    <col class="w-[60%] sm:w-[70%]">
                </colgroup>
                <thead>
                    <tr>
                        <th v-for="column in tableData.keys()" 
                            :key="column" 
                            class="bg-sky-600 p-1 sm:p-2 text-left text-white text-sm sm:text-base">
                            {{ column }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="index in 5" 
                        :key="index" 
                        :class="{'bg-slate-200': index % 2 !== 0}" 
                        class="h-8 sm:h-9">
                        <td v-for="value in tableData.values()" 
                            :key="value" 
                            class="p-1 sm:p-2 text-left overflow-hidden text-ellipsis whitespace-nowrap text-sm sm:text-base">
                            {{ value[index-1] }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
